import { useState } from 'react';
import { adminApi } from '../../api/admin';
import { useSession } from '../../auth/session';
import { Banner } from './ui';
import PushToggle from '../../components/PushToggle';

/** Admin's own account: profile details + change PIN. Nothing else. */
export default function AdminAccount() {
  const session = useSession();
  const [pin, setPin] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const minLen = 6; // admin PINs are 6–8 digits
  const canSave = pin.length >= minLen && pin.length <= 8 && pin === confirm && !saving;

  async function save() {
    if (!session || !canSave) return;
    setSaving(true); setErr(''); setMsg('');
    try {
      await adminApi.saveOperator({
        operatorId: session.operatorId,
        name: session.operatorName,
        role: session.role,
        active: true,
        pin,
      });
      setPin(''); setConfirm('');
      setMsg('PIN changed. Use the new PIN next time you sign in.');
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Could not change the PIN.');
    } finally {
      setSaving(false);
    }
  }

  if (!session) return null;

  return (
    <div>
      <h1>My account</h1>

      <div className="card">
        <div className="row"><span className="k">Name</span><span className="v">{session.operatorName}</span></div>
        <div className="row"><span className="k">Employee ID</span><span className="v">{session.operatorId}</span></div>
        <div className="row"><span className="k">Role</span><span className="v" style={{ textTransform: 'capitalize' }}>{session.role}</span></div>
      </div>

      <PushToggle />

      <h2>Change PIN</h2>
      <Banner error={err} ok={msg || undefined} />
      <div className="card" style={{ maxWidth: 420 }}>
        <label>New PIN <span className="muted">(6–8 digits)</span></label>
        <input inputMode="numeric" autoComplete="new-password" value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 8))} />
        <label>Confirm new PIN</label>
        <input inputMode="numeric" autoComplete="new-password" value={confirm}
          onChange={(e) => setConfirm(e.target.value.replace(/\D/g, '').slice(0, 8))} />
        {confirm.length > 0 && pin !== confirm && <p className="error tiny">PINs don’t match.</p>}
        <button onClick={save} disabled={!canSave}>{saving ? 'Saving…' : 'Change PIN'}</button>
      </div>
    </div>
  );
}
